import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IPartnerImage } from "@/models/partner-image.entity";

export const PartnerImageDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IPartnerImage> {
  getIdentifier(entity: IPartnerImage): string {
    return entity.id;
  }
})();
